import { DatePipe } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ChipModule } from 'primeng/chip';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { Toast } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { IControllerList } from '../../../../models/controller';
import { Auth, UserRoles } from '../../../../services/auth';
import { Functions } from '../../../../services/shared/functions';
import { IconsStyles } from '../../../../services/shared/icons-styles';

@Component({
  selector: 'app-controller-list',
  imports: [
    TableModule,
    ChipModule,
    SkeletonModule,
    DatePipe,
    TooltipModule,
    Toast,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    SelectModule,
    FormsModule,
  ],
  providers: [MessageService],
  templateUrl: './controller-list.html',
  styleUrl: './controller-list.css',
})
export class ControllerList implements OnInit {
  controllers = input.required<IControllerList[]>();
  isLoading = input.required<boolean>();
  authService = inject(Auth);
  private router = inject(Router);

  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);
  statuses!: { label: string; value: string }[];
  controllerTypes!: { label: string; value: string }[];
  activatedStatuses!: { label: string; value: boolean }[];

  constructor(private messageService: MessageService) {}

  ngOnInit(): void {
    // TODO: Get them from the backend in the future!
    this.statuses = [
      { label: 'online', value: 'ONLINE' },
      { label: 'unused', value: 'UNUSED' },
      { label: 'timeout', value: 'TIMEOUT' },
      { label: 'secondary', value: 'SECONDARY' },
      { label: 'new', value: 'NEW' },
      { label: 'deactivated', value: 'DEACTIVATED' },
      { label: 'off', value: 'OFF' },
    ];

    this.controllerTypes = [
      { label: 'mbsa', value: 'mbsa' },
      { label: 'bsa', value: 'bsa' },
      { label: 'ypv', value: 'ypv' },
    ];

    this.activatedStatuses = [
      { label: 'Yes', value: true },
      { label: 'No', value: false },
    ];
  }

  goToDetail(event: any) {
    this.router.navigate([
      '/dashboard/installation',
      event.data.installationId,
      'controller',
      event.data.ID,
    ]);
  }

  showCopiedMessage() {
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Copied serial number',
    });
  }

  showAdminFields() {
    if (
      this.authService.hasRole(UserRoles.SUPER_ADMIN) ||
      this.authService.hasRole(UserRoles.ADMIN)
    ) {
      return true;
    }

    return false;
  }
}
